import React from "react";
import { NavLink } from "react-router-dom";
import ClientHeaderImage from "../../assets/images/clients/clients-banner.png";

const BannerSection = () => {
  return (
    <>
      <section className="topPageBanner _border-bottom">
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center max-width950">
              <div>
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  {" "}
                  <span className="roboto-bold">OUR</span> CLIENTS
                </h1>

                <p className="roboto-regular heading16px text-color-131415 mb30">
                  "Our customers love us so much, they've even started naming
                  their pets after us!"
                </p>

                <ul className="btn-sec">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Start Free Trial
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="text-center">
                <img
                  src={ClientHeaderImage}
                  className="img-responsive position-relative"
                  alt="Double Your Qualified Leads"
                />
              </div>
            </div>
          </div>
        </div>

        {/* <ul className="breadcrumbs-custom-path">
                    <li><NavLink to="/">Home</NavLink></li>
                    <li className="active"><i className="fas fa-angle-right mx-2"></i>Clients</li>
                </ul> */}
      </section>
    </>
  );
};
export default BannerSection;
